<template>
  <div id="app">
    <router-view />
    <customTabbar v-if="this.$route.path !== '/htmlContent'"></customTabbar>
  </div>
</template>
<script>
import { getUserInfo } from "@/api/modules/login";

export default {
  async created() {
    console.log(66, 88, this.$route);
  },
  methods: {},
};
</script>

<style lang="scss">
#app > div {
  padding-bottom: 60px;
  box-sizing: border-box;
}
</style>
